<app-loader *ngIf="isDisabled"></app-loader>
<form class="g-3" name="SubContractorForm" (ngSubmit)="Validate(SubContractorForm)" #SubContractorForm="ngForm"
    novalidate>
    <div class="card">
        <div class="card-header">
            Sub Contractor
        </div>
        <div class="card-body">
            <div class="card mb-2">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            AADHAAR CARD
                        </div>
                        <div class="col-auto">
                            <span class="badge verify"
                                [ngClass]="{'success': common.ToLowerCase(this.Detail.AadhaarVerificationStatus)=='verified', 'warning':common.ToLowerCase(this.Detail.AadhaarVerificationStatus)!='verified', }"><i
                                    class="bi me-1"
                                    [ngClass]="{'bi-shield-check': common.ToLowerCase(this.Detail.AadhaarVerificationStatus)=='verified', 'bi-shield-x': common.ToLowerCase(this.Detail.AadhaarVerificationStatus)!='verified',}"></i>{{this.Detail.AadhaarVerificationStatus}}</span>
                        </div>
                        <div class="col-auto"
                            *ngIf="common.ToLowerCase(this.Detail.AadhaarVerificationStatus)!='verified'">
                            <button type="button" (click)="aadhaarKyc()"
                                class="float-end btn btn-outline-light btn-sm"><i class="bi bi-file-earmark-check"></i>
                                Aadhaar KYC</button>
                        </div>
                        <div class="col-auto"
                            *ngIf="common.ToLowerCase(this.Detail.AadhaarVerificationStatus)=='verified'">
                            <label (click)="ResetVerification(1)" class="reset"><i class="bi bi-arrow-clockwise"></i>
                                Reset</label>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <img [src]="this.Detail.AadhaarPhotoURL??'../../../assets/noimage.jpg'"
                                style="background-color: white;" class="registrationImage">
                        </div>
                        <div class="col-md">
                            <div class="row">
                                <div class="aadhaar-card">
                                    <div class="aadhaar-field">
                                        <div class="aadhaar-label">Aadhaar Number:</div>
                                        <div class="aadhaar-value">{{this.Detail.AadharNoKyc}}</div>
                                    </div>
                                    <div class="aadhaar-field">
                                        <div class="aadhaar-label">Name as Aadhaar:</div>
                                        <div class="aadhaar-value">{{this.Detail.NameAsPerAadhar}}</div>
                                    </div>
                                    <div class="aadhaar-field">
                                        <div class="aadhaar-label">Date of Birth:</div>
                                        <div class="aadhaar-value">{{this.Detail.AadharBirthDate}}</div>
                                    </div>
                                    <div class="aadhaar-field">
                                        <div class="aadhaar-label">Gender:</div>
                                        <div class="aadhaar-value">
                                            {{common.ToLowerCase(this.Detail.AadhaarGender)=='m'?'Male':common.ToLowerCase(this.Detail.AadhaarGender)=='f'?'Female':(this.Detail.AadhaarGender!=null
                                            && this.Detail.AadhaarGender!='')?'Other':''}}</div>
                                    </div>
                                    <div class="aadhaar-field">
                                        <div class="aadhaar-label">Address 1:</div>
                                        <div class="aadhaar-value">{{this.Detail.AadharAddress1}}</div>
                                    </div>
                                    <div class="aadhaar-field">
                                        <div class="aadhaar-label">Address 2:</div>
                                        <div class="aadhaar-value">{{this.Detail.AadharAddress2}}</div>
                                    </div>
                                </div>
                                <!-- <div class="col-md-12"
                                    style="background-image: url(../../../assets/aadharbackground.jpg);background-size: cover;background-color: #fff;background-repeat: no-repeat;background-position: center">
                                    <div class="row" style="margin-top: 6rem;">
                                        <div class="col-md-auto aadharLabel">
                                            <label class="text-label-dark">Aadhaar Number</label>
                                        </div>
                                        <div class="col-md-5">
                                            <label class="text-label-light">{{this.Detail.AadharNo}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-auto aadharLabel">
                                            <label class="text-label-dark">Name as Aadhaar</label>
                                        </div>
                                        <div class="col-md-5">
                                            <label class="text-label-light">{{this.Detail.AadhaarName}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-auto aadharLabel">
                                            <label class="text-label-dark">Date of Birth</label>
                                        </div>
                                        <div class="col-md-5">
                                            <label class="text-label-light">{{this.Detail.AadhaarDateOfBirth}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-auto aadharLabel">
                                            <label class="text-label-dark">Gender</label>
                                        </div>
                                        <div class="col-md-5">
                                            <label
                                                class="text-label-light">{{common.ToLowerCase(this.Detail.AadhaarGender)=='m'?'Male':common.ToLowerCase(this.Detail.AadhaarGender)=='f'?'Female':(this.Detail.AadhaarGender!=null
                                                &&
                                                this.Detail.AadhaarGender!='')?'Other':''}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-auto aadharLabel">
                                            <label class="text-label-dark">Address 1</label>
                                        </div>
                                        <div class="col-md-5">
                                            <label class="text-label-light">{{this.Detail.AadhaarAddress1}}</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-auto aadharLabel">
                                            <label class="text-label-dark">Address 2</label>
                                        </div>
                                        <div class="col-md-5">
                                            <label class="text-label-light">{{this.Detail.AadhaarAddress2}}</label>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <div class="row"
                                *ngIf="this.Detail.AadharAttachment != null && this.Detail.AadharAttachment != ''">
                                <div class="col"></div>
                                <div class="col-auto" ngbDropdown>
                                    <i class="bi bi-three-dots-vertical" ngbDropdownToggle id="BasicPhoto"></i>
                                    <div ngbDropdownMenu aria-labelledby="BasicPhoto">
                                        <button ngbDropdownItem type="button"><a
                                                [href]="this.Detail.AadhaarAttachmentURL" target="_blank"><i
                                                    class="bi bi-eye me-2"></i>View</a></button>
                                        <button ngbDropdownItem type="button"
                                            (click)="fileVerifyAadharAttachment.click()"><i
                                                class="bi bi-pencil-square me-2"></i>Edit</button>
                                        <button ngbDropdownItem type="button" (click)="RemoveAttechment(1)"><i
                                                class="bi bi-trash me-2"></i>Delete</button>
                                    </div>
                                </div>
                            </div>
                            <Input id="contained-button-file"
                                (change)="upload($event,common.CompanyParameterValue.AadhaarFolder)"
                                name="VerifyAadharAttachment" accept=".jpeg,.jpg,.png,.pdf" type="file"
                                #fileVerifyAadharAttachment required ngbTooltip="Choose File" style="display: none;" />
                            <div class="col-12 ImageDiv">
                                <!-- <div class="upload-icon"
                                    [ngClass]="{'attechmentDisable':(this.Detail.AadharVerificationID == 0 || this.Detail.AadharVerificationID == null || this.Detail.AadharVerificationID == '' || this.Detail.AadharVerificationID == '0')}"
                                    *ngIf="this.Detail.AadhaarAttachment == null || this.Detail.AadhaarAttachment == ''"
                                    (click)="fileVerifyAadharAttachment.click()">
                                    <i class="bi bi-upload"></i>
                                    <br />
                                    <label>Upload</label>
                                </div> -->
                                <div class="upload-area"
                                    *ngIf="this.Detail.AadharAttachment == null || this.Detail.AadharAttachment == ''"
                                    (click)="fileVerifyAadharAttachment.click()">
                                    <div class="upload-icon">
                                        <i class="bi bi-cloud-arrow-up"></i>
                                    </div>
                                    <p class="mb-1">Upload Attachment</p>
                                    <small class="text-muted">JPEG, PNG or PDF</small>
                                </div>
                                <div ngbDropdown>
                                    <img *ngIf="this.Detail.AadharAttachment != null && this.Detail.AadharAttachment != ''  && !common.isPdf(this.Detail.AadharAttachment)"
                                        [src]="this.Detail.AadhaarAttachmentURL" class="registrationImage">

                                    <iframe
                                        *ngIf="this.Detail.AadharAttachment != null && this.Detail.AadharAttachment != '' && common.isPdf(this.Detail.AadharAttachment)"
                                        [src]="this.sanitizer.bypassSecurityTrustResourceUrl(this.Detail.AadhaarAttachmentURL)"
                                        style="height: 180px;width: -webkit-fill-available"
                                        class="registrationImage"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-md-auto">
                    <div class="row" *ngIf="this.Detail.Photo != null && this.Detail.Photo != ''">
                        <div class="col"><label for="Photo" class="text-label-dark">Photo <span
                                    class="mandatory-field">*</span></label></div>
                        <div class="col-auto" ngbDropdown>
                            <i class="bi bi-three-dots-vertical" ngbDropdownToggle id="Photo"></i>
                            <div ngbDropdownMenu aria-labelledby="Photo">
                                <button ngbDropdownItem type="button"><a [href]="this.Detail.PhotoURL"
                                        target="_blank"><i class="bi bi-eye me-2"></i>View</a></button>
                                <button ngbDropdownItem type="button" (click)="file.click()"><i
                                        class="bi bi-pencil-square me-2"></i>Edit</button>
                                <button ngbDropdownItem type="button" (click)="RemoveAttechment(2)"><i
                                        class="bi bi-trash me-2"></i>Delete</button>
                            </div>
                        </div>
                    </div>
                    <Input id="contained-button-file" (change)="upload($event,common.CompanyParameterValue.PhotoFolder)"
                        name="EmployeePhoto" accept=".jpeg,.jpg,.png" type="file" #file required
                        ngbTooltip="Choose File" style="display: none;" />
                    <div class="col-12 ImageDiv">
                        <!-- <div class="upload-icon" *ngIf="this.Detail.Photo == null || this.Detail.Photo == ''"
                            (click)="file.click()">
                            <i class="bi bi-upload"></i>
                            <br />
                            <label>Upload</label>
                        </div> -->
                        <div class="upload-area" *ngIf="this.Detail.Photo == null || this.Detail.Photo == ''"
                            (click)="file.click()">
                            <div class="upload-icon">
                                <i class="bi bi-person-circle"></i>
                            </div>
                            <p class="mb-1">Upload Photo</p>
                            <small class="text-muted">JPEG or PNG</small>
                        </div>
                        <div ngbDropdown>
                            <img *ngIf="this.Detail.Photo != null && this.Detail.Photo != ''"
                                [src]="this.Detail.PhotoURL" class="registrationImage">
                        </div>
                    </div>
                </div>
                <div class="col-md">
                    <div class="row">
                        <div class="col-md-12">
                            <label for="NameAsPerAadhar" class="text-label-dark">Name As Per Aadhar <span
                                    class="mandatory-field">*</span></label>
                            <input type="text" class="form-control" id="NameAsPerAadhar" name="NameAsPerAadhar"
                                pattern="[a-zA-Z ]*" (keypress)="common.AlphabetOnly($event,true)"
                                [(ngModel)]="this.Detail.NameAsPerAadhar" #NameAsPerAadhar="ngModel" maxlength="100"
                                required [disabled]="VerificationStatus.AADHAARCardVerificationEnabled && this.VerificationStatus.CompulsoryAADHAARKYCVerification">
                            <div class="invalid-feedback">
                                Please enter name as per aadhar!
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label for="FirstName" class="text-label-dark">First Name <span
                                    class="mandatory-field">*</span></label>
                            <input type="text" class="form-control" placeholder="Ex. John" id="FirstName"
                                name="FirstName" pattern="[a-zA-Z ]*" (keypress)="common.AlphabetOnly($event,true)"
                                [(ngModel)]="this.Detail.FirstName" #FirstName="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please enter first name!
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="MiddleName" class="text-label-dark">Middle Name</label>
                            <input type="text" class="form-control" placeholder="Ex. Smith" id="MiddleName"
                                name="MiddleName" pattern="[a-zA-Z ]*" (keypress)="common.AlphabetOnly($event,true)"
                                [(ngModel)]="this.Detail.MiddleName" #MiddleName="ngModel" maxlength="100">
                            <div class="invalid-feedback">
                                Please enter middle name!
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="LastName" class="text-label-dark">Last Name <span
                                    class="mandatory-field">*</span></label>
                            <input type="text" class="form-control" placeholder="Ex. Alexander" id="LastName"
                                name="LastName" pattern="[a-zA-Z ]*" (keypress)="common.AlphabetOnly($event,true)"
                                [(ngModel)]="this.Detail.LastName" #LastName="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please enter last name!
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label for="GenderID" class="text-label-dark">Gender<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="GenderId" placeholder="Select Gender" [items]="Genders"
                                bindLabel="GenderName" bindValue="GenderMasterID" [(ngModel)]="this.Detail.GenderId"
                                [selectOnTab]="true" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select gender!
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="DateOfBirth" class="text-label-dark">Date Of Birth <span
                                    class="mandatory-field">*</span></label>
                            <div class="input-group">
                                <input class="form-control" placeholder="DD MMM YYYY" name="DateOfBirth"
                                    [minDate]="MinDate" [(ngModel)]="this.Detail.BirthDateObj" ngbDatepicker
                                    #DateOfBirth="ngbDatepicker" required readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="DateOfBirth.toggle()"
                                    type="button"></button>
                                <div class="invalid-feedback">
                                    please enter birthdate!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card" style="margin-top:2rem">
                <div class="card-header">
                    Posting Detail
                </div>
                <div class="card-body">
                    <div class="row mb-1" [ngClass]="{'gap-1': this.Detail.EmpMasterId > 0}">
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="BranchID" class="text-label-dark">Branch<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="BranchID" placeholder="Select Branch" [items]="Branchs"
                                bindLabel="BranchName" bindValue="BranchMasterID" [(ngModel)]="this.Detail.BranchID"
                                (change)="ComboLoad('Client')" [selectOnTab]="true" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select branch!
                            </div>
                        </div>
                        <div class="col-md" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Branch</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.BranchName}}</div>
                            </div>
                        </div>
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="ClientID" class="text-label-dark">Client<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="ClientID" placeholder="Select Client" [items]="Clients"
                                bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                                [(ngModel)]="this.Detail.ClientId" (change)="ComboLoad('Site')" [selectOnTab]="true"
                                required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select client!
                            </div>
                        </div>
                        <div class="col-md" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Client</div>
                            </div>
                            <div class="row bghighlight">
                                <div>{{this.Detail.ClientGroupName}}</div>
                            </div>
                        </div>
                        <div class="col-md-6" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="SiteID" class="text-label-dark">Site<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="SiteID" placeholder="Select Site" [items]="Sites" bindLabel="SiteName"
                                bindValue="SiteMasterID" [(ngModel)]="this.Detail.SiteId"
                                (change)="ComboLoad('Designation')" [selectOnTab]="true" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select site!
                            </div>
                        </div>
                        <div class="col-md-6" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Site</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.SiteCode +'-'+ this.Detail.SiteName}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1" [ngClass]="{'gap-1': this.Detail.EmpMasterId > 0}">
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="VendorID" class="text-label-dark">Vendor<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="VendorID" placeholder="Select Vendor" [items]="Vendors"
                                bindLabel="VendorName" bindValue="VendorId" [(ngModel)]="this.Detail.VendorId"
                                [selectOnTab]="true" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select vendor!
                            </div>
                        </div>
                        <div class="col-md" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Vendor</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.VendorCode +'-' +this.Detail.VendorName}}</div>
                            </div>
                        </div>

                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="DesignationID" class="text-label-dark">Designation<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="DesignationID" placeholder="Select Designation" [items]="Designations"
                                bindLabel="DesignationName" bindValue="DesignationMasterID"
                                [(ngModel)]="this.Detail.DesignationId" (change)="ComboLoad('Duty')"
                                [selectOnTab]="true" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select designation!
                            </div>
                        </div>
                        <div class="col-md" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Designation</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.DesignationName}}</div>
                            </div>
                        </div>
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="DutyID" class="text-label-dark">Duty<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="DutyID" placeholder="Select Duty" [items]="Dutys" bindLabel="DutyName"
                                bindValue="DutyMasterID" [(ngModel)]="this.Detail.DutyId"
                                (change)="ComboLoad('ShiftLoadBasedOnDesignationDuty')" [selectOnTab]="true" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select duty!
                            </div>
                        </div>
                        <div class="col-md" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Duty</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.DutyName}}</div>
                            </div>
                        </div>
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="ShiftID" class="text-label-dark">Shift<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="ShiftID" placeholder="Select Shift" [items]="Shifts" bindLabel="ShiftTitle"
                                bindValue="ShiftMasterID" [(ngModel)]="this.Detail.ShiftId" [selectOnTab]="true"
                                required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select shift!
                            </div>
                        </div>
                        <div class="col-md" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Shift</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.ShiftCode +'-'+this.Detail.ShiftTitle}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1" [ngClass]="{'gap-1': this.Detail.EmpMasterId > 0}">
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId == 0">
                            <label for="ServiceTypeID" class="text-label-dark">Service Type<span
                                    class="mandatory-field">*</span></label>
                            <ng-select name="ServiceTypeID" placeholder="Select Service Type" [items]="ServiceTypes"
                                bindLabel="ServiceTypeName" bindValue="ServiceTypeID"
                                [(ngModel)]="this.Detail.ServiceTypeId" [selectOnTab]="true" required disabled>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select service type!
                            </div>
                        </div>
                        <div class="col-md-3" *ngIf="this.Detail.EmpMasterId > 0">
                            <div class="row bghighlight">
                                <div class="text-label">Service Type</div>
                            </div>
                            <div class="row text-right bghighlight">
                                <div>{{this.Detail.ServiceType}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="button" (click)="Deactive()" class="btn btn-danger" [disabled]="isDisabled"
                    *ngIf="this.Detail.EmpMasterId > 0 && this.common.PageRight.IsEdit"><i class="bi bi-x-square"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Deactive':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="((this.Detail.EmpMasterId == 0 && this.common.PageRight.IsAdd) || (this.Detail.EmpMasterId > 0 && this.common.PageRight.IsEdit))"><i
                        class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>